module.exports = __webpack_public_path__ + "static/media/002-yoga.a85bf514.svg";